import { PaymentDto } from './payment.dto';
import { PaymentMethodVerificationDto } from './paymentMethodVerification.dto';
import { WebPaymentResponseDto } from './web-payment.response.dto';
import { SurfboardOrderCreationResponse } from '../interface/surfboard';

export class PaymentResponseV2Dto {
  success: boolean;
  processingUrl: string;
  payment: PaymentDto | WebPaymentResponseDto | PaymentMethodVerificationDto;
  formData: any;
  surfboardResponse?: SurfboardOrderCreationResponse
}
